import React, { useState } from "react";
import CorrectionTable from "../../../components/CorrectionTable";
import Applicability_of_new_TDS_forms from "../../../components/Applicability_of_new_TDS_forms";

const FAQComponent = () => {
  const [activeTab, setActiveTab] = useState("PAN");
  const [openFAQ, setOpenFAQ] = useState(null);
  const linkData = {
    PAN: [
      {
        text: "What is PAN?",
        content: "Permanent Account Number (PAN) is a ten-digit alphanumeric identifier, issued by Income Tax Department. Each assessee (e.g. individual, firm, company etc.) is issued a unique PAN.",
      },
      {
        text: "Who can apply for PAN?",
        content: "All existing assessees of taxpayers or persons who are required to file a return of income, even on behalf of others, must have a PAN. Any person, who intends to enter into economic or financial transactions where quoting PAN is mandatory, must also have a PAN.",
      },
      {
        text: "Who can apply PAN on behalf of minor or a person who is mentally ill or of unsound mind, and wards of court?",
        content: "Section 303 of IT Act, 2025 provides that a minor, or a person who is mentally ill or of unsound mind, and wards of court may be represented through a Representative Assessee. In such cases: -\n\n- In the application for PAN, details of the minor, or a person who is mentally ill or of unsound mind, and wards of court, etc. should be provided.",
      },
      {
        text: "Is it compulsory to quote PAN on 'return of income'?",
        content: "Yes, it is compulsory to quote PAN on return of income.",
      },
      {
        text: "Do I need to apply for a new PAN when I move from one city to another?",
        content: "No, Permanent Account Number (PAN), as the name suggests, is a permanent number and does not change. Changing the address though, may change the Assessing Officer.",
      },
      {
        text: "Can I have more than one PAN?",
        content: "No. Obtaining/possessing more than one PAN is against the law and may attract a penalty up to ₹ 10,000.",
      },
      {
        text: "What should I do if I have more than one PAN?",
        content: "You may fill and submit PAN Change Request application form by mentioning the PAN which you are using currently on top of the form. All other PANs inadvertently allotted to you should be mentioned at item no. 11 of the form and the corresponding PAN card copies should be submitted for cancellation along with the form.",
      },
      {
        text: "Is there any third party verification conducted to verify identity and address of PAN applicants along with genuineness of documents submitted by them?",
        content: "Yes. As per procedure prescribed by Income Tax Department, third party verification may be conducted to verify identity and address of PAN applicants along with genuineness of documents submitting by them during PAN application.",
      },
      {
        text: "What is e-PAN? Is e-PAN a valid proof of allotment of PAN?",
        content: "e-PAN is a digitally signed PAN card issued in electronic form and it is a valid proof of allotment of PAN.",
      },
      {
        text: "Is email ID mandatory for receiving e-PAN?",
        content: "Yes, it is mandatory to mention valid e-mail ID in PAN application form to receive e-PAN.",
      },
      {
        text: "Is it compulsory to link Aadhaar with PAN?",
        content: "Section 139AA of the Income Tax Act states that every person who has been allotted PAN as on July 1, 2017 is required to link his/her PAN with his/her Aadhaar number.",
      },
      // {
      //   text: "What is the deadline to link Aadhaar with PAN?",
      //   content: "Aadhaar-PAN linking deadline has been extended till March 31, 2022.",
      // },
      {
        text: "How do I link my Aadhaar with PAN?",
        content: "(A) You may visit e-filing website of Income Tax Department https://www.incometax.gov.in/iec/foportal or Protean e-Gov TIN website tinpan.proteantech.in and link your Aadhaar with PAN.\n\n(B) Alternatively, you can link your Aadhaar with PAN by sending SMS in the following format to 567678:\nUIDAIPAN<SPACE><12 digit Aadhaar><SPACE><10 digit PAN>",
      },
      {
        text: "What should I do if I am unable to link my Aadhaar with PAN either online or through SMS facility as mentioned above?",
        content: "You can link your Aadhaar with PAN using Biometric Aadhaar Authentication services. Click here to download Aadhaar Seeding Request Form and visit designated PAN center for Biometric Aadhaar Authentication along with supporting documents i.e. copy of PAN card and Aadhaar card.",
      },
      {
        text: "What is the new DigiLocker facility in the PAN application?",
        content: "This facility allows you to securely link your DigiLocker account to your online PAN application. By doing so, you can directly fetch your verified digital documents (like your Driving Licence or Birth Certificate) as proof, eliminating the need to manually scan and upload them.",
      },
      {
        text: "What are the benefits of using DigiLocker for my PAN application?",
        content: "Faster Processing: Because the documents are digitally verified and untampered, your application bypasses manual back-office human verification, moving straight to processing.\n• Paperless & Secure: You do not need to print, sign, scan, or upload physical documents.\n• Error-Free: Your details are securely pulled straight from government databases, reducing the risk of data rejection.",
      },
      {
        text: "Which documents are handled by DigiLocker and which by Aadhaar?",
        content: "When you choose the Aadhaar-based online application mode:\n• Your Proof of Identity (POI) and Proof of Address (POA) are automatically verified using your Aadhaar Card.\n• Your Proof of Date of Birth (DOB) can be pulled securely from DigiLocker using an approved document of your choice.",
      },
      {
        text: "Which documents can I fetch from DigiLocker for my Date of Birth (DOB) proof?",
        content: "You can select any of the following valid documents from the dropdown list on the application page to pull from DigiLocker:\n• Birth Certificate issued by the Municipal Authority or any authorized office\n• Driving Licence\n• Matriculation Certificate\n• Matriculation Marksheet of a Recognized Board\n• Marriage Certificate issued by the Registrar of Marriages\n• Domicile Certificate issued by the Government\n• Other documents as specified under Rule 158 of Income Tax Rules, 2026",
      },
      {
        text: "What should I do if I only have one of these unsupported documents?",
        content: "If you choose to use a Passport, Voter ID, CGHS, or Ex-Servicemen Card, you will need to bypass the automated DigiLocker flow and manually upload a scanned copy of the document for verification.",
      },
      {
        text: "Which documents cannot be verified automatically via DigiLocker for Date of Birth (DoB)?",
        content: "The following documents are currently not supported by DigiLocker for instant DoB verification:\n• Passport\n• EPIC / Voter ID Card\n• CGHS Card\n• Ex-Servicemen Contributory Health Scheme Photo Card",
      },
      {
        text: "What should I do if I don’t have a DigiLocker account?",
        content: "As soon as you select the Aadhaar-based application mode, the system will give you a \"Register Now\" option. Clicking this will instantly redirect you to the official DigiLocker portal (https://www.digilocker.gov.in/) where you can create your account and issue your documents in a few minutes. Once done, you can return to complete your PAN application.",
      },
      {
        text: "What if I already have a DigiLocker account?",
        content: "Simply select “Fetch via DigiLocker\". You will fill out your PAN details normally, and when you reach the final document submission page, you will be prompted to log into DigiLocker to pull your chosen document.",
      },
      {
        text: "I selected \"Driving Licence\" on the PAN application page, but I don’t have my Driving Licence issued inside my DigiLocker account. What should I do?",
        content: "Your DigiLocker document selection must exactly match the choice you made on the PAN application page. If your Driving Licence is not available in your DigiLocker vault, you cannot switch it directly inside the DigiLocker interface. Instead, you must cancel the current fetch process, return to the Protean PAN application screen, select a different valid proof (such as Birth Certificate) from the dropdown list, and then click “Fetch via DigiLocker\" again to log in and retrieve that specific document.",
      },
      {
        text: "Is it safe to share my documents via DigiLocker?",
        content: "Yes, completely. DigiLocker is a secure cloud-based platform provided by the Government of India. The platform shares your document data in an encrypted, digitally signed XML format. Protean only accesses the specific document you explicitly give consent to share.",
      },
      {
        text: "What happens if the DigiLocker system fails or cannot fetch my document?",
        content: "If there is a technical error, a network issue, or your document isn't supported, the application will smoothly fall back to the standard manual submission mode. You will be able to scan and upload your documents manually just as before, ensuring your application process isn't lost.",
      },
      {
        text: "Will I still get confirmation messages about my application status?",
        content: "Yes. All standard communication protocols remain exactly the same. You will receive real-time updates, token generation emails, payment receipts, and acknowledgment numbers via your registered email and mobile number, just at a much faster processing speed.",
      },
      {
        text: "Who should I contact if I encounter errors while registering with DigiLocker or am unable to pull my documents?",
        content: "Errors encountered while registering with DigiLocker or issues with pulling documents from DigiLocker are not handled by Protean. Applicants need to get in touch directly with the DigiLocker helpdesk to resolve such concerns.",
      },
    ],
    TAN: [
      {
        text: "What is TAN?",
        content: "TAN or Tax Deduction and Collection Account Number is a 10 digit alpha numeric number required to be obtained by all persons who are responsible for deducting or collecting tax. It is compulsory to quote TAN in all TDS/TCS returns (including e-TDS/TCS return), TDS/TCS payment challans and TDS/TCS certificates.",
      },
      {
        text: "Why is it necessary to have TAN?",
        content: "The provisions of Section 397 of Income-tax Act, 2025  require all persons who deduct or collect tax at source to apply for the allotment of TAN. The section also makes it mandatory to quote TAN in all TDS/TCS/Annual Information Returns, payment challans and certificates to be issued. If TAN is not quoted, TDS/TCS returns will not be accepted by TIN-Facilitation Centres (TIN-FCs) and challans for TDS/TCS payments will not be accepted by banks. Failure to apply for TAN or not quoting the same in the specified documents attracts a penalty of Rs. 10,000.",
      },
      {
        text: "Who must apply for TAN?",
        content: "All those persons who are required to deduct/collect tax at source on behalf of Income Tax Department are required to apply for and obtain TAN.",
      },
    ],
    "e-TDS/TCS": [
      {
        text: "What is quarterly e-TDS/TCS statement?",
        content: "TDS/TCS returns filed electronically under sections 200(3)/206C of the Income Tax Act are known as quarterly e-TDS/TCS statements. These statements are required to be filed from FY 2005-06 onwards. However, as per the instructions of the Income Tax Department, acceptance of e-TDS/TCS statements for Financial Years prior to FY 2007-08 has been discontinued at TIN. For statements up to FY 2025-26, the applicable forms are Form 24Q, Form 26Q, Form 27Q, and Form 27EQ. From FY 2026-27 onwards, the revised forms will be Form No. 138 (Form No 24Q), Form No. 140 (Form No 26Q), Form No. 144 (Form No 27Q), and Form No. 143 (Form No 27EQ). e-TDS/TCS statements submitted through CD/Pen Drive must also be accompanied by a signed verification in Form No. 27A.",
      },
      {
        text: "Who is required to file e-TDS/TCS statements?",
        content: "As per Income Tax Act, 1961, all corporate and government deductors/collectors are compulsorily required to file their TDS/TCS statements in electronic form i.e. e-TDS/TCS returns. However, deductors/collectors other than corporate/government can file either in physical or in electronic form.",
      },
      {
        text: "e-TDS/TCS statement have been made mandatory for Government deductors. How do I know whether I am a Government deductor or not?",
        content: "All Drawing and Disbursing Officers of Central and State Governments come under the category of Government deductors.",
      },
      {
        text: "Under what provision should e-TDS/TCS statement be filed?",
        content: "An e-TDS statement should be filed under Section 206 of the Income Tax Act in accordance with the scheme dated August 26, 2003 for electronic filing of TDS statement notified by the Central Board of Direct Taxes (CBDT) for this purpose. CBDT Circular No. 8 dated September 19, 2003 may also be referred. An e-TCS statement should be filed under Section 206C of the Income Tax Act in accordance with the scheme dated March 30, 2005 for electronic filing of TCS return notified by the CBDT for this purpose. As per section 200(3)/206C, as amended by Finance Act, 2005, deductors/collectors are required to file quarterly TDS/TCS statements from FY 2005-06 onwards.",
      },
      {
        text: "Who is the e-Filing Administrator?",
        content: "CBDT has appointed the Director General of Income Tax (Systems) as e-Filing Administrator for the purpose of electronic filing of TDS/TCS statement.",
      },
      {
        text: "Who is an e-TDS/TCS intermediary?",
        content: "CBDT has appointed Protean e-Gov Technologies Limited, (Protean), Mumbai, as e-TDS/TCS intermediary. Protean has established TIN Facilitation Centres (TIN-FCs) across the country to facilitate deductors/collectors file their e-TDS/TCS statement.",
      },
      {
        text: "Can we get details about foreign remittance (Form 15CA)? Can we get re-print of our Form 15CA?",
        content: "With effect from February 12, 2014, functionality of furnishing the foreign remittance details in Form 15CA and its related features have been discontinued from TIN and same are made available on the e-filing portal of Income Tax Department www.incometaxindiaefiling.gov.in",
      },
      {
        text: "Restrictions pertaining to filing of correction statements (Applicable from 1st April 2026)",
        content: (
          <>
            <p style={{ marginBottom: "16px" }}>
            Under Sec. 397(3) of the New Income Tax Act, 2025, corrections are allowed within two years from the end of the relevant tax. Submit TDS/TCS correction statements for FY 2018-19 (Q4) to FY 2023-24 (Q3) by 31.03.2026. From 01.04.2026, filings are time barred due to repeal of the Income Tax Act, 1961. 
            </p>
            <ul>
              <li style={{ marginBottom: "16px" }}>
                1. What is the new time limit for filing the TDS/TCS Correction Statement?
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  As per the Income Tax provisions, filing of TDS/TCS Correction Statement will not be allowed after two years from the end of financial year for which the original statement was filed. 
                  </li>
                </ul>
              </li>
              <li style={{ marginBottom: "16px" }}>
                2. From when are these changes applicable? 
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  These changes will be effective from April 1, 2026.
                  </li>
                </ul>
              </li>
              <li style={{ marginBottom: "16px" }}>
                3. Which forms will be affected by this restriction on correction statement? 
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  The restriction will apply to all form types: 24Q, 26Q, 27Q and 27EQ
                  </li>
                </ul>
              </li>
              <li style={{ marginBottom: "16px" }}>
                4. How long can a Correction Statement be filed for each quarter?
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  For Quarter 1, 2 and 3, corrections can be made within two subsequent financial years. 
                  </li>
                  <li>
                  For Quarter 4, corrections can be filed within two subsequent financial years plus one additional year, as the filing due date for Q4 falls in subsequent financial year. 
                  </li>
                </ul>
              </li>
            </ul>

            <p style={{ marginBottom: "16px" }}><strong>For Instance:</strong></p>

            <CorrectionTable /> {/* Render the table here */}

            <br></br>
            <ul>
              <li style={{ marginBottom: "16px" }}>
                5. Can I still file my TDS/TCS Correction Statement before April 1, 2026, as per old rules?
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  Yes, until March 31, 2026, Correction Statements can be filed as per existing rules. 
                  </li>
                </ul>
              </li>
              <li style={{ marginBottom: "16px" }}>
                6. What happens if any deductor/collector files a Correction Statement after two years limit?
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  Once the time limit expires (two years for Q1-Q3 and three years for Q4), no Correction Statements will be accepted.
                  </li>
                </ul>
              </li>
              <li style={{ marginBottom: "16px" }}>
                7. What if the deductor/collector still wants to file Correction Statement after the time limit? 
                <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                  <li>
                  Since these restrictions are imposed as per guidelines prescribed by Income Tax Department, if the deductor/collector has concerns regarding same, they may approach Assessing Officer of Income Tax Department for further guidance. 
                  </li>
                </ul>
              </li>
            </ul>
          </>
        ),
      },
      {
        text: "Applicability of new TDS forms?",
        content:(
          <>
          <span>
            NEW TDS FORMS APPLICABLE FROM APRIL 1, 2026
          </span> <br></br>
          <Applicability_of_new_TDS_forms />
          </>
        ),
          
      },
    ],
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setOpenFAQ(null);
  };

  const handleFAQClick = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const half = Math.ceil(linkData[activeTab].length / 2);
  const leftColumn = linkData[activeTab].slice(0, half);
  const rightColumn = linkData[activeTab].slice(half);

  return (
    <section className="w-full flex flex-col relative lg:px-0 bg-black lg:py-10">
      {/* Tabs */}
      <div className="flex px-[22px] lg:px-[70px] gap-2 items-center w-full py-4">
        <svg
          width="34"
          height="17"
          viewBox="0 0 34 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 8.5C0 13.1944 3.80558 17 8.5 17V0C3.80558 0 0 3.80558 0 8.5Z"
            fill="#54AD47"
          />
          <path
            d="M8.5 8.5C8.5 13.1944 12.3056 17 17 17V0C12.3056 0 8.5 3.80558 8.5 8.5Z"
            fill="#54AD47"
          />
          <circle cx="25.5" cy="8.5" r="8.5" fill="#54AD47" />
        </svg>
        <h3 className="font-semibold text-white text-[26px]">FAQ’s</h3>
      </div>
      <div className="lg:px-[70px]">
        {/* Mobile Dropdown */}
        <div className="block lg:hidden my-4 px-[22px] ">
          <select
            value={activeTab}
            onChange={(e) => handleTabClick(e.target.value)}
            className="w-full p-2 border-[1px] border-[#514B4B] bg-black text-white rounded-md"
          >
            <option value="PAN">PAN</option>
            <option value="TAN">TAN</option>
            <option value="e-TDS/TCS">e-TDS/TCS</option>
          </select>
        </div>

        {/* Desktop Tabs */}
        <div className="hidden lg:flex justify-between items-center border-b border-gray-600 mb-4">
          {["PAN", "TAN", "e-TDS/TCS"].map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              className={`text-white py-2 px-2 lg:min-w-[384px] focus:outline-none ${activeTab === tab ? "border-b-2 border-[#54AD47]" : ""
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row lg:space-x-8 px-[22px] lg:px-[70px] py-4 ">
          <div className="flex-1">
            {leftColumn.map((item, index) => (
              <div key={index} className="mt-4">
                <button
                  onClick={() => handleFAQClick(index)}
                  className="flex justify-between items-center text-left w-full p-2 border-b border-gray-600 text-white"
                >
                  {item.text}
                  <span>
                    {openFAQ === index ? (
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-up"
                      >
                        <polyline points="18 15 12 9 6 15"></polyline>
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-down"
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    )}
                  </span>
                </button>
                {openFAQ === index && (
                  <div className="p-2 text-white bg-black  whitespace-pre-line">{item.content}</div>
                )}
              </div>
            ))}
          </div>
          <div className="flex-1">
            {rightColumn.map((item, index) => (
              <div key={index} className="mt-4">
                <button
                  onClick={() => handleFAQClick(index + half)}
                  className="flex justify-between items-center text-left w-full p-2 border-b border-gray-600 text-white"
                >
                  {item.text}
                  <span>
                    {openFAQ === index + half ? (
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-up"
                      >
                        <polyline points="18 15 12 9 6 15"></polyline>
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-down"
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    )}
                  </span>
                </button>
                {openFAQ === index + half && (
                  <div className="p-2 text-white bg-black whitespace-pre-line">{item.content}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQComponent;
